export default __webpack_public_path__ + "static/citrus-f5de587bc5241dbecfe8983599ee6461.jpg";